import { createSelector } from "reselect";
import dayjs from "dayjs";

export function getShowNextDate(completed = false) {
  try {
    const now = dayjs();
    const nextShowDate = completed ? now.add(10, "year") : now.add(1, "week");
    return nextShowDate.format();
  } catch (error) {
    return null;
  }
}

export const selectModalSignupShow = createSelector(
  [
    state => state?.modalSignup.modalSignupShowNext,
    state => !!state.login.auth.expires,
  ],
  (modalSignupShowNext, authenticated) => {
    try {
      if (authenticated) {
        return false;
      }

      if (!modalSignupShowNext) {
        return true;
      }

      const now = dayjs();
      const nextShowDate = dayjs(modalSignupShowNext);
      return now.isAfter(nextShowDate);
    } catch (error) {
      return true;
    }
  }
);

export const selectSignupFooterShow = createSelector(
  [
    state => state?.modalSignup.signupFooterShowNext,
    state => !!state.login.auth.expires,
  ],
  (signupFooterShowNext, authenticated) => {
    try {
      if (authenticated) {
        return false;
      }

      if (!signupFooterShowNext) {
        return true;
      }

      const now = dayjs();
      const nextShowDate = dayjs(signupFooterShowNext);
      return now.isAfter(nextShowDate);
    } catch (error) {
      return true;
    }
  }
);
